// iluminacao.jsx
// Configuração centralizada dos circuitos de iluminação

export const iluminacaoConfig = [
  // TERREO CIRCUITOS 1 - 20
  { id: "grupo01", modulo: "7", idx: "1", descricao: "circuito 01", x: 13, y: 23, width: 2.5, height: 5, circleNumber:1, lightType: "normal", multipleInstances:[
    { x: 16.5, y: 22.8, width: 2.5, height: 5, circleNumber: 1 },
    { x: 11.5, y: 22.8, width: 2.5, height: 5, circleNumber: 1 },
    { x: 20.6, y: 22.8, width: 2.5, height: 5, circleNumber: 1 },
    { x: 23.5, y: 15, width: 2.5, height: 5, circleNumber: 1 },
    ]},
  { id: "grupo02", modulo: "7", idx: "2", descricao: "circuito 02", x: 0, y: 0, width: 0, height: 0, circleNumber: 2, lightType: "normal",multipleInstances:[
    { x: 3.5, y: 39.8, width: 2.5, height: 5, circleNumber: 2 },
    { x: 15.5, y: 15.5, width: 2.5, height: 5, circleNumber: 2 },
    { x: 4.5, y: 15.5, width: 2.5, height: 5, circleNumber: 2 },
    { x: 6, y: 1, width: 2.5, height: 5, circleNumber: 2 },
    { x: 17, y: 1, width: 2.5, height: 5, circleNumber: 2 },
    { x: 39, y: 1, width: 2.5, height: 5, circleNumber: 2 },
    { x: 6, y: 65, width: 2.5, height: 5, circleNumber: 2 },
    { x: 11, y: 84, width: 2.5, height: 5, circleNumber: 2 },
    { x: 60, y: 89, width: 2.5, height: 5, circleNumber: 2 },
    { x: 27, y: 87, width: 2.5, height: 5, circleNumber: 2 },
    { x: 79, y: 89, width: 2.5, height: 5, circleNumber: 2 },
    { x: 91.9, y: 86, width: 2.5, height: 5, circleNumber: 2 },
    { x: 84.5, y: 84, width: 2.5, height: 5, circleNumber: 2 },
    ]},
  { id: "grupo03", modulo: "7", idx: "3", descricao: "circuito 03", x: 0, y: 0, width: 0, height: 0, circleNumber: 3, lightType: "normal", },
  { id: "grupo04", modulo: "7", idx: "4", descricao: "circuito 04", x: 0, y: 0, width: 0, height: 0, circleNumber: 4, lightType: "normal", },
  { id: "grupo05", modulo: "1", idx: "1", descricao: "circuito 05", x: 40, y: 58, width: 2.5, height: 5, circleNumber: 5, lightType: "normal",multipleInstances:[
    { x: 40.5, y: 57.5, width: 2.5, height: 5, circleNumber: 5 },
    { x: 50, y: 52, width: 2.5, height: 5, circleNumber: 5 },
        { x: 49, y: 36, width: 2.5, height: 5, circleNumber: 5 },
    ]},
  { id: "grupo06", modulo: "1", idx: "2", descricao: "circuito 06", x: 0, y: 0, width: 0, height: 0, circleNumber: 6, lightType: "normal", multipleInstances:[
    { x: 31, y: 33, width: 2.5, height: 5, circleNumber: 6 },
    { x: 31, y: 60, width: 2.5, height: 5, circleNumber: 6 },
    ]},
  { id: "grupo07", modulo: "1", idx: "3", descricao: "circuito 07", x: 0, y: 0, width: 0, height: 0, circleNumber: 7, lightType: "normal", multipleInstances:[
    { x: 41, y: 74, width: 2.5, height: 5, circleNumber: 7 },
    { x: 32, y: 72.5, width: 2.5, height: 5, circleNumber: 7 },
    ]},
  { id: "grupo08", modulo: "1", idx: "4", descricao: "circuito 08", x: 52, y: 18, width: 2.5, height: 5, circleNumber: 8, lightType: "normal", multipleInstances:[
    { x: 52, y: 18, width: 2.5, height: 5, circleNumber: 8 },
    { x: 42, y: 26, width: 2.5, height: 5, circleNumber: 8 },
    { x: 54, y: 34, width: 2.5, height: 5, circleNumber: 8 },
    ]},
  { id: "grupo09", modulo: "1", idx: "5", descricao: "circuito 09", x: 60, y: 39, width: 2.5, height: 5, circleNumber: 9, lightType: "normal", multipleInstances:[
    { x: 60, y: 39, width: 2.5, height: 5, circleNumber: 9 },
    { x: 57.5, y: 62, width: 2.5, height: 5, circleNumber: 9 },
    ]},
  { id: "grupo10", modulo: "1", idx: "6", descricao: "circuito 10", x: 0, y: 0, width: 0, height: 0, circleNumber: 10, lightType: "normal",multipleInstances:[
    { x: 41.5, y: 17, width: 2.5, height: 5, circleNumber:10 },
    { x: 45, y: 34.5, width: 2.5, height: 5, circleNumber:10 },
    { x: 50, y: 25.5, width: 2.5, height: 5, circleNumber:10 },
    ]},
  { id: "grupo11", modulo: "1", idx: "7", descricao: "circuito 11", x: 0, y: 0, width: 0, height: 0, circleNumber: 11, lightType: "normal", multipleInstances:[
    { x: 54, y: 35, width: 2.5, height: 5, circleNumber:11 },
    { x: 54, y: 57, width: 2.5, height: 5, circleNumber:11 },
    { x: 60, y: 56, width: 2.5, height: 5, circleNumber:11 },
  ]},
  { id: "grupo12", modulo: "1", idx: "8", descricao: "circuito 12", x: 45, y: 58, width: 2.5, height: 5, circleNumber: 12, lightType: "normal", },
  { id: "grupo13", modulo: "2", idx: "1", descricao: "circuito 13", x: 500, y: 0, width: 0, height: 0, circleNumber: 13, lightType: "normal", },
  { id: "grupo14", modulo: "2", idx: "2", descricao: "circuito 14", x: 500, y: 0, width: 0, height: 0, circleNumber: 14, lightType: "normal", },
  { id: "grupo15", modulo: "2", idx: "3", descricao: "circuito 15", x: 58, y: 71, width: 2.5, height: 5, circleNumber: 15, lightType: "normal", },
  { id: "grupo16", modulo: "2", idx: "4", descricao: "circuito 16", x: 0, y: 0, width: 0, height: 0, circleNumber: 16, lightType: "normal", 
  multipleInstances:[
    { x: 54, y: 77.5, width: 2.5, height: 5, circleNumber:16 },
    { x: 39.5, y: 72, width: 2.5, height: 5, circleNumber:16 },
  ]},
  { id: "grupo17", modulo: "2", idx: "5", descricao: "circuito 17", x: 0, y: 0, width: 0, height: 0, circleNumber: 17, lightType: "normal",
  multipleInstances:[
    { x: 23, y: 42, width: 2.5, height: 5, circleNumber: 17 },
    { x: 16, y: 42, width: 2.5, height: 5, circleNumber: 17 },
  ]},
  { id: "grupo18", modulo: "2", idx: "6", descricao: "circuito 18", x: 0, y: 0, width: 0, height: 0, circleNumber: 18, lightType: "normal",
  multipleInstances:[
    { x: 20.5, y: 64, width: 2.5, height: 5, circleNumber: 18 },
    { x: 30.5, y: 76, width: 2.5, height: 5, circleNumber: 18 },
  ]},
  { id: "grupo19", modulo: "2", idx: "7", descricao: "circuito 19", x: 0, y: 0, width: 0, height: 0, circleNumber: 19, lightType: "normal", 
  multipleInstances:[
    { x: 75.5, y: 41, width: 2.5, height: 5, circleNumber: 19 },
    { x: 72.5, y: 25, width: 2.5, height: 5, circleNumber: 19 },
  ]},
  { id: "grupo20", modulo: "2", idx: "8", descricao: "circuito 20", x: 0, y: 0, width: 0, height: 0, circleNumber: 20, lightType: "normal",
  multipleInstances:[
    { x: 73, y: 66, width: 2.5, height: 5, circleNumber: 20 },
    { x: 65.65, y: 60, width: 2.5, height: 5, circleNumber: 20 },
    { x: 79.5, y: 57, width: 2.5, height: 5, circleNumber: 20 },
    { x: 79.5, y: 41, width: 2.5, height: 5, circleNumber: 20 },
  ]},

  // TERREO CIRCUITOS 21 - 40
  { id: "grupo21", modulo: "3", idx: "1", descricao: "circuito 21", x: 72.5, y: 4.2, width: 2.5, height: 5, circleNumber: 21, lightType: "normal", },
  { id: "grupo22", modulo: "3", idx: "2", descricao: "circuito 22", x: 59, y: 4.2, width: 2.5, height: 5, circleNumber: 22, lightType: "normal", },
  { id: "grupo23", modulo: "3", idx: "3", descricao: "circuito 23", x: 0, y: 0, width: 0, height: 0, circleNumber: 23, lightType: "normal", 
  multipleInstances:[
    { x: 82.5, y: 19.75, width: 2.5, height: 5, circleNumber: 23 },
    { x: 82.5, y: 32.75, width: 2.5, height: 5, circleNumber: 23 },
    { x: 82.5, y: 45.75, width: 2.5, height: 5, circleNumber: 23 },
    { x: 95.5, y: 19.75, width: 2.5, height: 5, circleNumber: 23 },
    { x: 95.5, y: 32.75, width: 2.5, height: 5, circleNumber: 23 },
    { x: 95.5, y: 45.75, width: 2.5, height: 5, circleNumber: 23 },
  ]},
  { id: "grupo24", modulo: "3", idx: "4", descricao: "circuito 24", x: 72, y: 72, width: 2.5, height: 5, circleNumber: 24, lightType: "normal", },
  { id: "grupo25", modulo: "4", idx: "1", descricao: "circuito 25", x: 89, y: 75, width: 2.5, height: 5, circleNumber: 25, lightType: "normal", },
  { id: "grupo26", modulo: "4", idx: "2", descricao: "circuito 26", x: 76.5, y: 21, width: 2.5, height: 5, circleNumber: 26, lightType: "normal", },
  { id: "grupo27", modulo: "4", idx: "3", descricao: "circuito 27", x: 0, y: 0, width: 0, height: 0, circleNumber: 27, lightType: "normal", },
  { id: "grupo28", modulo: "4", idx: "4", descricao: "circuito 28", x: 0, y: 0, width: 0, height: 0, circleNumber: 28, lightType: "normal", },
  { id: "grupo29", modulo: "5", idx: "1", descricao: "circuito 29", x: 0, y: 0, width: 0, height: 0, circleNumber: 29, lightType: "normal", },
  { id: "grupo30", modulo: "5", idx: "2", descricao: "circuito 30", x: 0, y: 0, width: 0, height: 0, circleNumber: 30, lightType: "normal", },
  { id: "grupo31", modulo: "5", idx: "3", descricao: "circuito 31", x: 0, y: 0, width: 0, height: 0, circleNumber: 31, lightType: "normal", },
  { id: "grupo32", modulo: "5", idx: "4", descricao: "circuito 32", x: 0, y: 0, width: 0, height: 0, circleNumber: 32, lightType: "normal", },
];

// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};